import { render } from "./PollResults.vue?vue&type=template&id=868509c2"
import script from "./PollResults.vue?vue&type=script&lang=js"
export * from "./PollResults.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__